// @ts-strict-ignore
import { Injectable } from '@angular/core';

import { LMActionService } from '@services/lm-action.service';
import { LMLoggerService } from '@services/lm-logger.service';

@Injectable()
export class LMListActionUtilService {
  constructor(
    private lmActionService: LMActionService,
    private lmLoggerService: LMLoggerService
  ) {}

  public getValidUpdateAction(actionSpecs: Array<LMActionSpec>, dataViewSet: LMDataViewSet, rows: Array<number>): LMActionSpec {
    const validUpdateActions: Array<LMActionSpec> = this.lmActionService.getValidListUpdateActions(actionSpecs, dataViewSet, rows);
    return (validUpdateActions && validUpdateActions.length > 0) ? validUpdateActions[0] : null;
  }
}
